import React, { useState } from "react";
import { Container, Row, Col, Form, Card, Button } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import validator from "validator";
import { ENV } from "../../config/config";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { useCreateAwardMutation, useDeleteAwardMutation } from "../../redux/api";

const AwardForm = ({ oldAward, permissions }) => {
  const [createAward, { isLoading: isCreatingAward }] = useCreateAwardMutation();
  const [deleteAwardMut, { isLoading: isDeletingAward }] = useDeleteAwardMutation();
  const [awards, setAwards] = useState([]);
  const [msg, setMsg] = useState({});

  const handleFileChange = (e) => {
    const acceptedExtensions = [".jpg", ".jpeg", ".png"];
    const validFiles = [];
    Array.from(e.target.files).forEach((file) => {
      const fileExtension = "." + file.name.split(".").pop().toLowerCase();
      if (acceptedExtensions.includes(fileExtension)) {
        validFiles.push(file);
      } else {
        toast.error(
          `Invalid file extension for ${
            file.name
          }. Valid extensions are: ${acceptedExtensions.join(", ")}`
        );
      }
    });

    const count = oldAward.length + awards.length;
    const newFiles = validFiles.slice(0, 4 - count);
    const newAwards = newFiles.map((file) => ({
      file,
      image: URL.createObjectURL(file),
      url: "",
      location: "",
      year: "",
      title: "",
    }));
    setAwards([...awards, ...newAwards]);
    const dataTransfer = new DataTransfer();
    newFiles.forEach((file) => dataTransfer.items.add(file));
    awards.forEach((file) => dataTransfer.items.add(file.file));
    e.target.files = dataTransfer.files;
  };

  const handleRemoveImage = (index) => {
    const newAwards = [...awards];
    newAwards.splice(index, 1);
    setAwards(newAwards);
  };

  const handleChange = (index, key, value) => {
    const newAwards = [...awards];
    newAwards[index][key] = value;
    setAwards(newAwards);

    if (key === "url") {
      const newMsg = { ...msg };
      if (!validator.isURL(value)) {
        newMsg[`url${index}`] = "Invalid URL";
      } else {
        delete newMsg[`url${index}`];
      }
      setMsg(newMsg);
    }
    if (key === "location") {
      const newMsg = { ...msg };
      if (validator.isEmpty(value)) {
        newMsg[`location${index}`] = "Location is required";
      } else {
        delete newMsg[`location${index}`];
      }
      setMsg(newMsg);
    }
    if (key === "title") {
      const newMsg = { ...msg };
      if (validator.isEmpty(value)) {
        newMsg[`title${index}`] = "Title is required";
      } else {
        delete newMsg[`title${index}`];
      }
      setMsg(newMsg);
    }
    if (key === "year") {
      const newMsg = { ...msg };
      if (validator.isEmpty(value)) {
        newMsg[`year${index}`] = "Year is required";
      } else {
        delete newMsg[`year${index}`];
      }
      setMsg(newMsg);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    let isValid = true;
    const newMsg = { ...msg };
    const formData = new FormData();
    awards.forEach((award, index) => {
      if (award.file) {
        formData.append("awardImage", award.file);
      }
      if (!validator.isURL(award.url)) {
        newMsg[`url${index}`] = "Invalid URL";
        isValid = false;
      }
      if (validator.isEmpty(award.location)) {
        newMsg[`location${index}`] = "Location is required";
        isValid = false;
      }
      if (validator.isEmpty(award.title)) {
        newMsg[`title${index}`] = "Title is required";
        isValid = false;
      }
      if (validator.isEmpty(award.year)) {
        newMsg[`year${index}`] = "Year is required";
        isValid = false;
      }
      formData.append(`awardUrl${index}`, award.url);
      formData.append(`awardLocation${index}`, award.location);
      formData.append(`awardTitle${index}`, award.title);
      formData.append(`awardYear${index}`, award.year);
    });

    setMsg(newMsg);
    if (isValid) {
      (async () => {
        await createAward(formData);
        setAwards([]);
        setMsg({});
      })();
    }
  };

  const deleteHandler = (catId) => {
    Swal.fire({
      title: "Are you sure you want to delete?",
      html: "If you delete an item, it will lost permanently.",
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.value) {
        (async () => {
          await deleteAwardMut(catId);
        })();
      }
    });
  };

  return (
    <Container fluid>
      <Row>
        <Col md="12">
          <Form
            action=""
            className="form-horizontal"
            id="TypeValidation"
            onSubmit={handleSubmit}
          >
            <Card className="table-big-boy p-5">
              {/* Awards */}
              <Card className="table-big-boy mb-5">
                <Card.Header>
                  <div className="d-block d-md-flex align-items-center justify-content-between">
                    <Card.Title as="h4">Our Awards</Card.Title>
                  </div>
                </Card.Header>

                <Card.Body>
                  <Form.Group>
                    <Form.Label className="d-block mb-2">
                      Upload Images
                    </Form.Label>
                    <Form.Control
                      type="file"
                      multiple
                      onChange={handleFileChange}
                      accept="image/*"
                      disabled={
                        oldAward?.length + awards.length === 4 ? true : false
                      }
                    />
                  </Form.Group>
                  <Row>
                    {oldAward &&
                      oldAward.map((award, index) => (
                        <Col
                          xl={4}
                          md={6}
                          key={index}
                          className="position-relative"
                        >
                          <FaTimes
                            onClick={() => deleteHandler(award.id)}
                            className="position-absolute"
                            style={{
                              top: "10px",
                              right: "30px",
                              color: "red",
                              fontSize: "1.5rem",
                              cursor: "pointer",
                              zIndex: "999",
                            }}
                          />
                          <img
                            src={ENV.assetsUrl + "about/" + award.image}
                            alt={`Award ${index}`}
                            className="img-fluid"
                          />
                          <Form.Group>
                            <Form.Label className="d-block mb-2">
                              URL
                            </Form.Label>
                            <Form.Label className="d-block mb-2">
                              {award.url}
                            </Form.Label>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label className="d-block mb-2">
                              Title
                            </Form.Label>
                            <Form.Label className="d-block mb-2">
                              {award.title}
                            </Form.Label>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label className="d-block mb-2">
                              Year
                            </Form.Label>
                            <Form.Label className="d-block mb-2">
                              {award.year}
                            </Form.Label>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label className="d-block mb-2">
                              Location
                            </Form.Label>
                            <Form.Label className="d-block mb-2">
                              {award.location}
                            </Form.Label>
                          </Form.Group>
                        </Col>
                      ))}
                    {awards.map((award, index) => (
                      <Col
                        xl={4}
                        md={6}
                        key={index}
                        className="position-relative"
                      >
                        <FaTimes
                          onClick={() => handleRemoveImage(index)}
                          className="position-absolute"
                          style={{
                            top: "10px",
                            right: "30px",
                            color: "red",
                            fontSize: "1.5rem",
                            cursor: "pointer",
                            zIndex: "999",
                          }}
                        />
                        <img
                          src={award.image}
                          alt={`Award ${index}`}
                          className="img-fluid"
                        />
                        <Form.Group>
                          <Form.Label className="d-block mb-2">URL</Form.Label>
                          <Form.Control
                            type="text"
                            value={award.url}
                            onChange={(e) =>
                              handleChange(index, "url", e.target.value)
                            }
                          />
                          {msg[`url${index}`] && (
                            <span className="text-danger">
                              {msg[`url${index}`]}
                            </span>
                          )}
                        </Form.Group>
                        <Form.Group>
                          <Form.Label className="d-block mb-2">
                            Title
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={award.title}
                            onChange={(e) =>
                              handleChange(index, "title", e.target.value)
                            }
                          />
                          {msg[`title${index}`] && (
                            <span className="text-danger">
                              {msg[`title${index}`]}
                            </span>
                          )}
                        </Form.Group>
                        <Form.Group>
                          <Form.Label className="d-block mb-2">Year</Form.Label>
                          <Form.Control
                            type="text"
                            value={award.year}
                            onChange={(e) =>
                              handleChange(index, "year", e.target.value)
                            }
                          />
                          {msg[`year${index}`] && (
                            <span className="text-danger">
                              {msg[`year${index}`]}
                            </span>
                          )}
                        </Form.Group>
                        <Form.Group>
                          <Form.Label className="d-block mb-2">
                            Location
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={award.location}
                            onChange={(e) =>
                              handleChange(index, "location", e.target.value)
                            }
                          />
                          {msg[`location${index}`] && (
                            <span className="text-danger">
                              {msg[`location${index}`]}
                            </span>
                          )}
                        </Form.Group>
                      </Col>
                    ))}
                  </Row>
                </Card.Body>
              </Card>
              <hr className="centered-hr" />

              <Card.Footer>
                <Row className="float-right">
                  {permissions && permissions.editSetting && (
                    <Col sm={12} className="d-flex">
                      <Button
                        className="btn-filled mt-3"
                        type="submit"
                        disabled={oldAward && oldAward.length >= 4}
                      >
                        Save
                      </Button>
                    </Col>
                  )}
                </Row>
              </Card.Footer>
            </Card>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default AwardForm;
